import React, { useState } from "react";

const initialTemplates = [
    { 
        id: 1, 
        name: "Approval Email", 
        subject: "Your account has been approved", 
        body: "Hello {name},\n\nYour account has been successfully approved. You can now log in to the system and start using our services.\n\nRegards,\nTeam" 
    },
    { 
        id: 2, 
        name: "License Purchase Email", 
        subject: "License Purchase Confirmation", 
        body: "Hello {name},\n\nThank you for purchasing the license. Your transaction was successful.\n\nLicense Key: {license_key}\nValid Until: {valid_until}\n\nRegards,\nTeam" 
    },
    { 
        id: 3, 
        name: "Credit Recharge/Limit Email", 
        subject: "Credit Recharge Successful", 
        body: "Hello {name},\n\nYour credit recharge of {amount} was successful. Your new credit limit is {new_limit}.\n\nRegards,\nTeam" 
    }
];

function EmailTemplates() {
    const [templates, setTemplates] = useState(initialTemplates);
    const [selectedTemplate, setSelectedTemplate] = useState(initialTemplates[0]);
    const [isEditing, setIsEditing] = useState(false);

    const handleSelect = (tmpl) => {
        // If we are editing, we might want to ask for confirmation, 
        // but for simplicity we'll just discard unsaved changes and switch.
        // Re-find from state to discard unsaved edits.
        const original = templates.find(t => t.id === tmpl.id);
        setSelectedTemplate(original);
        setIsEditing(false);
    };

    const handleSave = () => {
        // Here we would typically make an API call
        setTemplates(templates.map(t => t.id === selectedTemplate.id ? selectedTemplate : t));
        setIsEditing(false);
        alert("Template saved successfully (Frontend only)");
    };

    return (
        <div className="container" style={{ minHeight: "71vh", paddingTop: "2%" }}>
            <h3 className="title-of-page">Email Templates</h3>
            <p className="text-muted">Manage the email templates sent out by the system.</p>
            
            <div className="row mt-4">
                <div className="col-md-4">
                    <div className="list-group shadow-sm">
                        {templates.map(tmpl => (
                            <button
                                key={tmpl.id}
                                className={`list-group-item list-group-item-action ${selectedTemplate.id === tmpl.id ? 'active' : ''}`}
                                onClick={() => handleSelect(tmpl)}
                                style={{
                                    backgroundColor: selectedTemplate.id === tmpl.id ? "rgba(85, 71, 159, 0.9)" : "white",
                                    borderColor: selectedTemplate.id === tmpl.id ? "rgba(85, 71, 159, 0.9)" : "#ddd",
                                    color: selectedTemplate.id === tmpl.id ? "white" : "#333",
                                    fontWeight: selectedTemplate.id === tmpl.id ? "bold" : "normal",
                                    padding: "15px 20px"
                                }}
                            >
                                {tmpl.name}
                            </button>
                        ))}
                    </div>
                </div>
                
                <div className="col-md-8">
                    <div className="card shadow-sm border-0" style={{ border: "1px solid #ddd" }}>
                        <div className="card-header bg-white d-flex justify-content-between align-items-center" style={{ padding: "15px 20px", borderBottom: "1px solid #eee" }}>
                            <h5 className="mb-0" style={{ color: "rgba(85, 71, 159, 0.9)", fontWeight: "bold" }}>
                                {selectedTemplate.name}
                            </h5>
                            {!isEditing && (
                                <button 
                                    className="btn btn-sm px-4 py-2" 
                                    style={{ backgroundColor: "rgba(85, 71, 159, 0.9)", color: "white", borderRadius: "6px", fontWeight: "bold" }} 
                                    onClick={() => setIsEditing(true)}
                                >
                                    Edit Template
                                </button>
                            )}
                        </div>
                        <div className="card-body" style={{ padding: "24px" }}>
                            {isEditing ? (
                                <form>
                                    <div className="form-group mb-4">
                                        <label className="fw-bold mb-2">Email Subject</label>
                                        <input 
                                            type="text" 
                                            className="form-control p-2" 
                                            style={{ border: "1px solid #ccc", borderRadius: "6px" }}
                                            value={selectedTemplate.subject} 
                                            onChange={(e) => setSelectedTemplate({...selectedTemplate, subject: e.target.value})}
                                        />
                                    </div>
                                    <div className="form-group mb-4">
                                        <label className="fw-bold mb-2">Email Body</label>
                                        <textarea 
                                            className="form-control p-3" 
                                            rows="10" 
                                            style={{ border: "1px solid #ccc", borderRadius: "6px", resize: "vertical" }}
                                            value={selectedTemplate.body}
                                            onChange={(e) => setSelectedTemplate({...selectedTemplate, body: e.target.value})}
                                        ></textarea>
                                        <small className="text-muted d-block mt-2">
                                            <strong>Note:</strong> You can use variables inside curly braces like {'{name}'}, {'{amount}'}, etc. They will be replaced dynamically.
                                        </small>
                                    </div>
                                    <div className="d-flex justify-content-end gap-3 mt-4 pt-3 border-top">
                                        <button 
                                            type="button" 
                                            className="btn btn-outline-secondary px-4 py-2" 
                                            style={{ borderRadius: "6px", fontWeight: "bold" }} 
                                            onClick={() => handleSelect(selectedTemplate)}
                                        >
                                            Cancel
                                        </button>
                                        <button 
                                            type="button" 
                                            className="btn px-4 py-2" 
                                            style={{ backgroundColor: "rgba(85, 71, 159, 0.9)", color: "white", borderRadius: "6px", fontWeight: "bold" }} 
                                            onClick={handleSave}
                                        >
                                            Save Changes
                                        </button>
                                    </div>
                                </form>
                            ) : (
                                <div>
                                    <div className="mb-4">
                                        <h6 className="text-muted text-uppercase" style={{ fontSize: "0.85rem", letterSpacing: "1px", marginBottom: "8px" }}>Subject</h6>
                                        <div className="p-3 bg-light" style={{ border: "1px solid #e9ecef", borderRadius: "6px", fontSize: "1.05rem" }}>
                                            {selectedTemplate.subject}
                                        </div>
                                    </div>
                                    <div>
                                        <h6 className="text-muted text-uppercase" style={{ fontSize: "0.85rem", letterSpacing: "1px", marginBottom: "8px" }}>Body Content</h6>
                                        <div className="p-4 bg-light" style={{ border: "1px solid #e9ecef", borderRadius: "6px", whiteSpace: 'pre-wrap', lineHeight: "1.6", fontSize: "0.95rem" }}>
                                            {selectedTemplate.body}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmailTemplates;
